<template>
  <div class="page-redirect">
    <QueryInfo v-if="!!status" :mode="status"/>
    <InQuery v-else/>
  </div>
</template>

<script>
import InQuery from './components/in-query.vue'
import QueryInfo from './components/query-info.vue'
import {getAdvertiseApi, queryActiveByCodeApi} from "@/api";
import {isCottiApp, isWeixin, isWxMiniProgram,replaceParamVal} from "@/utils";

export default {
  name: 'PageRedirect',
  components: {
    InQuery, QueryInfo
  },
  data() {
    return {
      advertise: '',
      isLoading: false,
      status: '',
    }
  },
  methods: {
    async initAdv() {
      try {
        const {data} = await getAdvertiseApi({code: 'cotti-mkt-transferPage'})
        this.advertise = data[0].url
      } catch (e) {
        console.warn('getAdvertiseApi error', e)
      }
    },
    /**
     * 展示页面3：status 0 2 3 4 NOT_FOUND 和前端现有校验   暂无活动, 稍晚点再来看看吧～
       展示页面4：status  7  SCAN_ERROR 加载失败，请重新扫描
       展示页面5：status  8 QRCODE_INVALID 二维码已失效，请重新扫码
     */
    async init() {
      const utmSource = this.$route.query?.utm_source;
      const qrCode = this.$route.query?.qr;
      const channelType = this.$route.query?.channelType;
      const params = {
        'utSource': utmSource,
        'activityCode':qrCode,
        'channelType':channelType
      }
    
      if (!utmSource && !qrCode) {
        this.status = 'SCAN_ERROR';
        return
      }
      const userData = this.getUserData()
      this.isLoading = true
      
      try {
        const {data} = await queryActiveByCodeApi(params)
        this.$sensors.track("mkt_redirect_page_view", {
          'activityCode': qrCode,
          'utmSource': utmSource,
          'receive_result_status': data?.status,
        });
        console.log('data?.status === 8 ',data?.status === 8 )
        if (data?.status === 0 || data?.status === 2 || data?.status === 3 || data?.status === 4) {
          this.status = 'NOT_FOUND';
          return
        }else if (data?.status === 7 ){
          this.status = 'SCAN_ERROR';
          return
        }else if (data?.status === 8 ){
          this.status = 'QRCODE_INVALID';
          return
        }else if (data?.status === 39 ){
          this.status = 'SHOP_INVALID';
          return
        }else if (data?.status === 1 ){
          //等于1时，走跳转的逻辑
        }
        else{
          this.status = 'NOT_FOUND';
          return
        }
        // this.setPageTitle()
        const url = this.setChannel(data?.redirectUrl)
        const and = url?.includes('?') ? '&' : '?'
        location.replace(userData ? `${url}${and}${userData}` : url)
      } catch (e) {
        this.status = 'TIME_OUT';
        console.warn('queryActiveByCodeApi error', e)
      } finally {
        this.isLoading = false
      }
    },
    // 修改url中的渠道
    setChannel(url) {
      // 1 小程序 2 h5 3 app
      let from = 2
      if (isCottiApp()) {
        from = 3
      } else if (isWxMiniProgram()) {
        from = 1
      }
      if (!url?.includes('&a=') && !url?.includes('?a=')) {
        // 原来url里就没有a=的情况
        return url?.includes('?') ? `${url}&a=${from}` : `${url}&?=${from}`
      }
      return replaceParamVal(url,'a',from)
    },
    // 获取跳转到中转页的登录信息，整理成url string传给重定向的链接
    getUserData() {
      const queryObj = {
        mmm: this.$route.query?.mmm,
        contact_id: this.$route.query?.mmm,
        u_t: this.$route.query?.u_t,
        poi: this.$route.query?.poi || ''
      }
      let str = ""
      for (let i in queryObj) {
        let value = queryObj[i]// 定义变量接收对象的value值
        if (value) {
          str += `&${i}=${value}`// 进行字符串拼接
        }
      }
      return str
    },
    setPageTitle(title) {
      if (isCottiApp()) {
        try {
          TitleChange.postMessage(title);
        } catch (e) {
          console.error(e)
        }
      }
    }
  },
  created() {
    this.init()
    // this.initAdv()
  },
  mounted() {
    document.body.style.backgroundColor = '#F5F6F7'
  },
  beforeDestroy() {
    document.body.style.backgroundColor = '#fff'
  }
}
</script>

<style lang="scss" scoped>
.page-redirect {

  .title {
    text-align: center;
    margin-top: 16px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #5E5E5E;
    line-height: 20px;
    opacity: .4;
  }
}
</style>
